export const shipmentCols = [
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'cargoType',
        id: 'cargoType-col',
        fieldHeader: 'Cargo Type',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        isActionLink: true,
        accessor: 'bookingNumber',
        id: 'bookingNumber-col',
        fieldHeader: 'Booking Number',
        sortable: true,
        dataType: 'date'
    },
    {
        headerClassName: 'data-table header fixedNumber',
        className: 'fixedNumber',
        show: true,
        accessor: 'consigneeCountryCode',
        isActionLink: false,
        id: 'consigneeCountryCode-col-link',
        fieldHeader: 'Consignee Code',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'consigneeName',
        id: 'consigneeName-col',
        fieldHeader: 'Consignee Name',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'consigneeFACTCode',
        id: 'consigneeFACTCode-col',
        fieldHeader: 'Consignee Fact Code',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'consigneeSCVCode',
        id: 'consigneeSCVCode-col',
        fieldHeader: 'Consignee SCV Code',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'destinationSiteCode',
        id: 'destinationSiteCode-col',
        fieldHeader: 'Destination Site Code',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'destinationSiteName',
        id: 'destinationSiteName-col',
        fieldHeader: 'Destination Site Name',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'originSiteCode',
        id: 'originSiteCode-col',
        fieldHeader: 'Origin Site Code',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'originSiteName',
        id: 'originSiteName-col',
        fieldHeader: 'Origin Site Name',
        sortable: true
    }]
export const bookingCols = [{
    headerClassName: 'data-table header fixedNumber',
    className: 'fixedNumber',
    show: true,
    accessor: 'bookingNumber',
    isActionLink: true,
    id: 'bookingNumber-col-link',
    fieldHeader: 'Booking number',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'productType',
    id: 'product-type',
    fieldHeader: 'Product Type',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'origin',
    id: 'origin-col',
    fieldHeader: 'Origin Service',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'loadingPortCode',
    id: 'loadingPortCode-col',
    fieldHeader: 'Port of Loading',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'dischargePortCode',
    id: 'dischargePortCode-col',
    fieldHeader: 'Port of Discharge',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'destination',
    id: 'destination-col',
    fieldHeader: 'Destination Service',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'placeOfDeliveryCode',
    id: 'placeOfDelivery-col',
    fieldHeader: 'Place of Delivery',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'status',
    id: 'status-col',
    fieldHeader: 'Status',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'createDate',
    id: 'createDate-col',
    fieldHeader: 'Create Date',
    sortable: true,
    dataType: 'date'
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'lastChangedBy',
    id: 'lastChangedBy-col',
    fieldHeader: 'Last Update By',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'updateDate',
    id: 'lastChangeDate-col',
    fieldHeader: 'Update Date',
    sortable: true,
    dataType: 'date'
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'bookingId',
    id: 'bookingId-col',
    fieldHeader: 'Booking ID',
    sortable: true
}]